<script>
export default {
  components: {},
  // Disable automatic attribute inheritance, so that $attrs are
  // passed to the <input>, even if it's not the root element.
  // https://vuejs.org/v2/guide/components-props.html#Disabling-Attribute-Inheritance
  inheritAttrs: false,
  // Change the v-model event name to `update` to avoid changing
  // the behavior of the native `input` event.
  // https://vuejs.org/v2/guide/components-custom-events.html#Customizing-Component-v-model
  model: {
    event: 'update',
  },
  props: {
    error: {
      type: String,
      required: false,
      default: null,
    },
    light: {
      type: Boolean,
      required: false,
    },
    resize: {
      type: Boolean,
      required: false,
    },
    long: {
      type: Boolean,
      required: false,
    },
    short: {
      type: Boolean,
      required: false,
    },
    instruction: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<template>
  <div class="input-with-label">
    <textarea
      type="textarea"
      :class="[
        'input-textarea',
        {
          light: light,
          resize: resize,
          long: long,
          short: short,
          instruction: instruction,
        },
      ]"
      autocomplete="off"
      v-bind="
        $attrs
        // https://vuejs.org/v2/guide/components-props.html#Disabling-Attribute-Inheritance
      "
      @input="$emit('update', $event.target.value)"
      v-on="$listeners"
    />

    <span v-if="error" class="input-error-text">{{ error }}</span>
  </div>
</template>

<style lang="scss">
@import '@design';

.input-textarea {
  @extend %typography-small;

  background-color: $color-input-bg;
  border: 1px solid $color-input-bg;
  border-radius: $base-border-radius;
  display: block;
  line-height: 1.7;
  margin-bottom: 3.2rem;
  margin-top: 1.8rem;
  padding: $size-input-padding-vertical $size-input-padding-horizontal;
  transition: background $duration-animation-base, border $duration-animation-base;
  width: 100%;

  &::-webkit-scrollbar {
    height: 100%;
    width: 8px;
  }

  &:focus {
    background-color: $color-input-focus-bg;
    border: 1px solid $color-input-focus-border;
  }

  &.light {
    background-color: white;
  }

  &.resize {
    padding: 0;
  }

  &.long {
    max-height: 6.86em;
    width: 72.7%;
  }

  &.short {
    max-height: 6.86em;
    width: 72.7%;
  }

  &.instruction {
    display: block;
    margin: 0;
    margin-left: 2%;
    margin-right: 5%;
    overflow: hidden;
    padding: 0;
    width: 77%;
  }
}

.input-error {
  .input-textarea {
    background-color: $color-input-error-light;
    border: 1px solid $color-input-error-dark;
    margin-bottom: 1.2rem;
  }

  .input-error-text {
    color: $color-input-error-dark;
    display: block;
    margin-bottom: 3.2rem;
  }
}
</style>
